import styled from 'styled-components'
import { default as VARIABLES } from '../../themes/styles/variables'

// Wrapper
// ============================================================
export const SelectStyle = styled.div`
  /* Parent styles
  ------------------------------- */
  width: auto;
  min-width: 212px;
  display: inline-block;

  /* Child element styles
  ------------------------------- */
  /* .select__control,
  .css-tz2gqr-control {
    height: 40px;
    border-color: ${VARIABLES.COLORS.GRAY_2};
  }

  .select__indicator-separator {
    width: 0;
  }

  .select__dropdown-indicator {
    color: ${VARIABLES.COLORS.BLUE_1};
  }

  .select__clear-indicator {
    display: none;
    padding: 0;
  }
  .css-r8v8yh-control {
    .css-319lph-ValueContainer {
      .css-lr9fot-singleValue,
      .css-14el2xx-placeholder {
        color: ${VARIABLES.COLORS.GRAY_10};
      }
    }
  }
  .select__placeholder,
  .css-qc6sy-singleValue,
  .css-14el2xx-placeholder {
    color: ${VARIABLES.COLORS.GRAY_3};
  }

  .select--is-disabled {
    .select__control {
      background-color: ${VARIABLES.COLORS.GRAY_8};
      color: ${VARIABLES.COLORS.GRAY_10};
    }

    .select__indicators {
      display: none;
    }
  }

  .select__menu {
    .select__menu-list {
      color: ${VARIABLES.COLORS.BLUE_1};

      .group-head {
      }

      .group-option {
        padding-left: 40px;
      }
    }
  } */

  /* Modifiers
  ------------------------------- */
  &.table-filter {
    margin-left: 10px;

    &.all-pre-assessment {
      width: 225px;
    }
  }

  &.year-established-filter {
    width: 100%;
  }

  /* State
  ------------------------------- */
  &:hover {
    .select__clear-indicator {
      display: flex;
      padding: 8px 0 8px 8px;
    }
  }

  /* Media queries
  ------------------------------- */
`
